'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Heading(lead, accent, broken) {
  this.fe = null;
  this.fc = null;
  this.fd = false;
  this.fe = lead;
  this.fc = accent;
  this.fd = broken;
}
export { $c_Lio_intela_sites_intelacloud_content_Heading as $c_Lio_intela_sites_intelacloud_content_Heading };
$p = $c_Lio_intela_sites_intelacloud_content_Heading.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Heading;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Heading() {
}
export { $h_Lio_intela_sites_intelacloud_content_Heading as $h_Lio_intela_sites_intelacloud_content_Heading };
$h_Lio_intela_sites_intelacloud_content_Heading.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, (-1835002398));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().R(this.fe));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().R(this.fc));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, (this.fd ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().N(acc, 3);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Heading) && (((this.fd === x$0.fd) && (this.fe === x$0.fe)) && (this.fc === x$0.fc))));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "Heading";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.fe;
      break;
    }
    case 1: {
      return this.fc;
      break;
    }
    case 2: {
      return this.fd;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Heading(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bv)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Heading as $isArrayOf_Lio_intela_sites_intelacloud_content_Heading };
var $d_Lio_intela_sites_intelacloud_content_Heading = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Heading, "io.intela.sites.intelacloud.content.Heading", ({
  bv: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Heading as $d_Lio_intela_sites_intelacloud_content_Heading };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Heading.js.map
